var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#313131"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1170_1422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 20.3333L22 20.3333V22L2 22V20.3333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 2L3.37931 2L3.37931 18.5517H2L2 2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6207 2L22 2L22 18.5517H20.6207L20.6207 2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6552 8.2069H12.3448V18.5517H11.6552V8.2069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75862 11.6552H5.44828L5.44828 18.5517H4.75862L4.75862 11.6552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82759 11.6552L7.51724 11.6552L7.51724 18.5517H6.82759L6.82759 11.6552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89655 11.6552H9.58621L9.58621 18.5517H8.89655L8.89655 11.6552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4138 11.6552H15.1034V18.5517H14.4138V11.6552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4828 11.6552H17.1724V18.5517H16.4828V11.6552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5517 11.6552H19.2414L19.2414 18.5517H18.5517L18.5517 11.6552Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1170_1422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuler);
export default __webpack_public_path__ + "static/media/Ruler.c39e390281579fbd9453c6c1633cae98.svg";
export { ForwardRef as ReactComponent };